import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { motion } from "framer-motion";

const Contact_Section = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
    >
      <Box
        sx={{
          py: 10,
          backgroundImage:
            "url('https://rstheme.com/products/wordpress/konstruk/wp-content/uploads/2023/03/solar-eng-banner.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            {/* LEFT CONTENT */}
            <Grid item size={{ xs: 12, md: 6 }}>
              <motion.div
                initial={{ opacity: 0, x: -60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
              >
                <Typography
                  variant="subtitle2"
                  className="paraAfter-line"
                  // sx={{ color: "white", mb: 1, letterSpacing: 1 }}
                >
                  GET IN TOUCH
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    color: "white",
                    fontWeight: 700,
                    lineHeight: 1.2,
                    mb: 3,
                  }}
                >
                  Need Any Help? <br />
                  We’re Here for Your <br />
                  Support
                </Typography>

                <Typography sx={{ color: "white", mb: 4 }}>
                Our experienced team provides end-to-end assistance across construction materials, logistics, and project coordination. Reach out anytime for dependable service and expert guidance.
                </Typography>

                {/* Phone Button */}
                <Button
                  variant="outlined"
                  sx={{
                    color: "white",
                    borderColor: "white",
                    px: 4,
                    py: 1.5,
                    borderRadius: "30px",
                    fontWeight: 600,
                  }}
                  component="a"
                  href="tel:+919935701935"
                >
                  📞 (+91) 9935701935
                </Button>
              </motion.div>
            </Grid>

            {/* RIGHT FORM */}
            <Grid item size={{ xs: 12, md: 6 }}>
              <motion.div
                initial={{ opacity: 0, x: 60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
              >
                <Box
                  sx={{
                    backgroundColor: "#B40000",
                    p: 4,
                    borderRadius: "8px",
                  }}
                >
                  <Grid container spacing={3}>
                    {/* First Name */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <TextField
                        fullWidth
                        label="First Name*"
                        variant="outlined"
                        InputLabelProps={{ style: { color: "white" } }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            color: "white",
                            "& fieldset": { borderColor: "white" },
                            "&:hover fieldset": { borderColor: "white" },
                            "&.Mui-focused fieldset": { borderColor: "white" },
                          },
                        }}
                      />
                    </Grid>

                    {/* Last Name */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <TextField
                        fullWidth
                        label="Last Name*"
                        variant="outlined"
                        InputLabelProps={{ style: { color: "white" } }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            color: "white",
                            "& fieldset": { borderColor: "white" },
                            "&:hover fieldset": { borderColor: "white" },
                            "&.Mui-focused fieldset": { borderColor: "white" },
                          },
                        }}
                      />
                    </Grid>

                    {/* Email */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <TextField
                        fullWidth
                        label="Email*"
                        variant="outlined"
                        InputLabelProps={{ style: { color: "white" } }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            color: "white",
                            "& fieldset": { borderColor: "white" },
                            "&:hover fieldset": { borderColor: "white" },
                            "&.Mui-focused fieldset": { borderColor: "white" },
                          },
                        }}
                      />
                    </Grid>

                    {/* Project Scope */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <TextField
                        fullWidth
                        label="Project Scope*"
                        variant="outlined"
                        InputLabelProps={{ style: { color: "white" } }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            color: "white",
                            "& fieldset": { borderColor: "white" },
                            "&:hover fieldset": { borderColor: "white" },
                            "&.Mui-focused fieldset": { borderColor: "white" },
                          },
                        }}
                      />
                    </Grid>

                    {/* Message */}
                    <Grid item size={{ xs: 12 }}>
                      <TextField
                        fullWidth
                        label="Message*"
                        variant="outlined"
                        multiline
                        minRows={5}
                        InputLabelProps={{ style: { color: "white" } }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            color: "white",
                            "& fieldset": { borderColor: "white" },
                            "&:hover fieldset": { borderColor: "white" },
                            "&.Mui-focused fieldset": { borderColor: "white" },
                          },
                        }}
                      />
                    </Grid>

                    {/* Submit */}
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "white",
                          color: "#B40000",
                          fontWeight: 600,
                          px: 4,
                          py: 1.3,
                          borderRadius: "6px",
                          "&:hover": {
                            backgroundColor: "#f2f2f2",
                          },
                        }}
                        fullWidth={false}
                      >
                        Submit Now
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </motion.div>
  );
};

export default Contact_Section;
